"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
//
// assets
//
const editorLogo_svg_1 = __importDefault(require("assets/images/dashboard/editorLogo.svg"));
//
// styles
//
const styles_1 = require("./styles");
const Header = ({ name, noChanges, onBack, onPublish, onSave }) => (react_1.default.createElement(styles_1.StyledHeader, null,
    react_1.default.createElement(styles_1.ButtonLink, { "aria-label": 'Back', className: 'back', onClick: onBack, type: 'button' },
        react_1.default.createElement(styles_1.Icon, { className: 'fe fe-arrow-left' })),
    react_1.default.createElement(styles_1.Container, null,
        react_1.default.createElement(styles_1.Logo, { alt: 'Malomo', src: editorLogo_svg_1.default }),
        react_1.default.createElement(styles_1.Title, null, name)),
    react_1.default.createElement(styles_1.ButtonGroup, null,
        react_1.default.createElement(styles_1.Button, { onClick: onSave, secondary: true }, "Save"),
        react_1.default.createElement(styles_1.Button, { disabled: noChanges, onClick: onPublish }, "Publish"))));
Header.defaultProps = {
    name: ''
};
exports.default = Header;
